import { Outlet, Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { URL } from './url'
import React from 'react'

export const PrivateRoutes = () => {

    const session = useSelector((state) => state.session)

    return (
        session.accessToken ? <Outlet /> : <Navigate to={URL.LOGIN} />
    )
}